module.exports = __webpack_public_path__ + "img/password.20e8733a.png";